<mat-spinner [diameter]="diameter"></mat-spinner>